const AnalogData = {
  QUESTION: [
    {
      createdAt: 1595743032459,
      groupId: 1,
      id: 1,
      options: '[{"text":"YES","value":101},{"text":"NO","value":102}]',
      question: 'Are there any stop payments or temporary credit adjustments in the account in the last 90 days?',
      sortOrder: 101,
      status: 1,
      updatedAt: 1595743032563
    },
    {
      createdAt: 1595743032459,
      groupId: 1,
      id: 2,
      options: '[{"text":"YES","value":101},{"text":"NO","value":102}]',
      question: 'Does the address match the customer address on file?',
      sortOrder: 102,
      status: 1,
      updatedAt: 1595743032459
    },
    {
      groupId: 1,
      id: 3,
      options: '[{"text":"YES","value":101},{"text":"NO","value":102}]',
      question: 'Does the account allow unlimited credit/debit ACHs?Does the account allow unlimited credit/debit ACHs?',
      sortOrder: 103,
      status: 1
    },
    {
      groupId: 1,
      id: 4,
      options: '[{"text":"YES","value":101},{"text":"NO","value":102}]',
      question: 'Is <%= data.fullName %>, the name of the primary account holder listed in this account?',
      sortOrder: 104,
      status: 1
    },
    {
      groupId: 1,
      id: 5,
      options: '[{"text":"Next Business Day","value":1},{"text":"Same Day","value":0}]',
      question: 'After payroll deposits the funds, when will the money be available to the customer?',
      sortOrder: 105,
      status: 1
    }
  ]
}

export { AnalogData }
